import { NAME } from "./types";

export const getAll = state => state[NAME];
export const getUser = state => getAll(state).user;
export const getIsLoggedIn = state => getAll(state).isLoggedIn;
export const isPending = state => getAll(state).isPending;
export const isLoaded = state => getAll(state).isLoaded;
